import { CombinedGraphQLErrors, CombinedProtocolErrors } from "@apollo/client";

export const parseErrorFromGraphql = (error: any): string => {
  if (error.networkError) {
    const networkError = error.networkError;

    if ("status" in networkError && networkError.status === 503) {
      return "Tjenesten er utilgjengelig";
    }
    if ("status" in networkError && networkError.status === 500) {
      return "Ukjent feil fra tjenesten";
    }
    return (
      "Klarte ikke å laste inn data. Undersøk evt. nettverksproblemer og prøv igjen. Feilmelding: " +
      networkError.message
    );
  }

  if (CombinedGraphQLErrors.is(error)) {
    const firstError = error.errors[0];
    if (firstError && firstError.message) {
      return firstError.message;
    }
    return "Ukjent feil fra GraphQL";
  }

  if (CombinedProtocolErrors.is(error)) {
    const firstProtocolError = error.errors[0];
    if (firstProtocolError) {
      return firstProtocolError.message || "Ukjent protokollfeil";
    }
  }

  if (error.message) {
    return error.message;
  }

  return "Ukjent feil";
};
